/** @module MaterialSpec/MaterialFamilyColorRuleStateRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/Enum",
	"csi/heading/stateColorResolver"
], function(declare, Enum, stateColorResolver) {

	return declare(Enum, {
		bCopy: true,

		/**
		 * @override
		 * Apply the styling if needed
		 */
		_getRenderCSS(ctx, h) {
			const node = ctx.getNode();
			const revisionNode = ctx.getNode(node.CurrentRevision);
			return this.inherited(arguments) + " " + stateColorResolver.getStateCss(revisionNode);
		}
	});
});